import React from 'react'
import Subheader from '../../component/Subheader'
import WeddingSlider from '../wedding/WeddingSlider'
import MeetingBigimage from '../Meeting/MeetingBigimage'
import MeetingAbout from '../Meeting/MeetingAbout'
import MeetingValue from '../Meeting/MeetingValue'
import WeddingStory from '../wedding/WeddingStory'
import MeetingTeambuild from '../Meeting/MeetingTeambuild'

export default function MeetingGoa() {
  const subheadData = {
    heading: 'Meetings & Events Venues in Goa',
    breadcrumb: [
      {
        slug: "/resort-de-coracao-goa",
        name: "Goa",
      },
      {
        slug: "",
        name: "Meetings & Events",
      },
    ]
  }


  const slideData = {
    newClass: "meetpage-event",
    heading: "All Types of Corporate Events",
    slides: [
      {
        image: "/image/meeting-slide-1.webp",
        title: "Leadership <br /> Summits",
        desc: "A focused gathering of senior leaders to align vision, sharpen strategy, and accelerate organizational growth."
      },
      {
        image: "/image/meeting-slide-2.webp",
        title: "Corporate Award <br /> Nights",
        desc: "A distinguished celebration honoring achievements, outstanding performance, and organizational milestones in an elegant setting."
      },
      {
        image: "/image/meeting-slide-3.webp",
        title: "Executive <br /> Retreats",
        desc: "A private offsite designed for strategic planning, leadership alignment, meaningful collaboration, and focused decision-making."
      },
      {
        image: "/image/meeting-slide-4.webp",
        title: "Corporate <br /> Exhibitions",
        desc: "A curated platform for showcasing products, services, industry engagement, networking, and enhancing brand visibility."
      },
    ]
  }


  const storyData = {
    title: "Where strategic gatherings evolve into refined and impactful distinctive and memorable business experiences.",
    description: "What better setting for a distinctive corporate experience than a destination designed to inspire meaningful moments. Surrounded by Goa’s vibrant charm, De Coracao Resort offers 2 versatile event venues, thoughtfully curated for ideal corporate gatherings. Waves Conference Hall spans 1820 sq. ft. and accommodates up to 150 guests with flexible theatre, classroom, cluster, and banquet seating arrangements, making it ideal for conferences and seminars. The Executive Board Room, spread across 300 sq. ft., comfortably hosts up to 20 guests for focused meetings, presentations, and brainstorming sessions in an elegant setting.",
  }


  const bigImage = {
    image: "/image/meet-bigimage.webp",
  }


  const meetAbout = {
    para: "Beyond productive sessions, De Coracao Resort offers flexible venue layouts and modern facilities tailored to every corporate gathering. Waves Conference Hall accommodates 150 guests in theatre style, 110 in cluster seating, and 65 in U-shape arrangements, while the Board Room comfortably hosts 20 guests in both theatre and U-shape formats, ideal for presentations, discussions, and collaborative meetings in Goa.",
    image1: "/image/meetabout-1.webp",
    image2: "/image/meetabout-2.webp",
  }


  const meetValue = {
    title: "Added Values",
    para: "At De Coracao, we don't just provide a hall; we deliver an experience that aligns with your business goals. Our hospitality is about making your job easier and your event more impactful.",
    image: "/image/meetvalue-image.webp",
    list: [
      "Versatile Dining: Multiple venues offering everything from quick working lunches to elaborate gala dinners.",
      "Networking Spaces:Curated bar concepts and an exclusive evening lounge designed for relaxed, post-event conversations.",
      "Engagement-First Activities: Innovative team-building experiences that actually get people talking and collaborating.",
      "Dedicated Support: A personal on-site event coordinator to manage the moving parts, ensuring everything runs like clockwork.",
    ]
  }


  const teamBuild = {
    leftImage: "/image/meetteam-image.webp",
    leftTitle: "TEAM-BUILDING <br/> EXPERIENCES",
    subtitle: "Team-Building Experiences",
    button: {
      text: "Request for Proposal",
      link: "/contact-us"
    },
    slides: [
      {
        title: "Sandcastle Strategy Challenge",
        image: "/image/meetteam-slider-1.webp",
        desc: "A collaborative beach activity where teams design and build themed sand structures within a set timeframe, encouraging creativity, strategic planning, delegation, and teamwork in a relaxed coastal environment while fostering communication, leadership skills, innovation, coordination, and group synergy."
      },
      {
        title: "Coastal Volleyball Showdown",
        image: "/image/meetteam-slider-2.webp",
        desc: "A high-energy beachside competition where teams face off in fast-paced volleyball matches along Goa’s scenic coastline, enhancing communication, agility, and teamwork while fostering strong team bonding in a vibrant, competitive, and engaging coastal atmosphere with strategic play."
      }
    ]
  };

  return (
    <>
      <Subheader subheadData={subheadData} />
      <WeddingStory data={storyData} />
      <MeetingBigimage bigImage={bigImage} />
      <MeetingAbout meetAbout={meetAbout} />
      <MeetingValue meetValue={meetValue} />
      <WeddingSlider data={slideData} isBtn={false} />
      <MeetingTeambuild teamBuild={teamBuild} />
    </>
  )
}
